/* eslint-disable @typescript-eslint/naming-convention */

export enum MessageSource {
  PROVIDER_MANAGER = 'PROVIDER-MANAGER',
  PROVIDER_ADMIN = 'PROVIDER-ADMIN',
  PROFESIONAL = 'PROFESIONAL',
  ORDER_MANAGER = 'ORDER-MANAGER'
}
